(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('Kiosks', Kiosks)

    Kiosks.$inject = ['$resource'];

    function Kiosks($resource) {
        var resourceUrl = 'api/kiosk/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'}
        })
    }
})();
